export default {
  states: {
    success: 'Erfolg!',
    error: 'Fehler!',
  },
}
